import type {
  AdminPersonalAccessToken,
  CreatePersonalAccessTokenRequest,
  PersonalAccessToken,
  PersonalAccessTokenId,
  PersonalAccessTokenWithSecret,
} from "metabase-types/api";

import { Api } from "./api";
import {
  idTag,
  invalidateTags,
  listTag,
  providePersonalAccessTokenListTags,
} from "./tags";

export const personalAccessTokenApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    listCurrentPersonalAccessTokens: builder.query<PersonalAccessToken[], void>(
      {
        query: () => "/api/pat/current",
        providesTags: (tokens = []) =>
          providePersonalAccessTokenListTags(tokens),
      },
    ),
    createCurrentPersonalAccessToken: builder.mutation<
      PersonalAccessTokenWithSecret,
      CreatePersonalAccessTokenRequest
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/pat/current",
        body,
      }),
      invalidatesTags: (_, error) =>
        invalidateTags(error, [listTag("personal-access-token")]),
    }),
    revokeCurrentPersonalAccessToken: builder.mutation<
      void,
      PersonalAccessTokenId
    >({
      query: (id) => ({ method: "DELETE", url: `/api/pat/current/${id}` }),
      invalidatesTags: (_, error, id) =>
        invalidateTags(error, [
          listTag("personal-access-token"),
          idTag("personal-access-token", id),
        ]),
    }),
    listAdminPersonalAccessTokens: builder.query<
      AdminPersonalAccessToken[],
      void
    >({
      query: () => "/api/pat",
      providesTags: (tokens = []) => providePersonalAccessTokenListTags(tokens),
    }),
    countAdminPersonalAccessTokens: builder.query<number, void>({
      query: () => "/api/pat/count",
      providesTags: providePersonalAccessTokenListTags([]),
    }),
    revokeAdminPersonalAccessToken: builder.mutation<
      void,
      PersonalAccessTokenId
    >({
      query: (id) => ({ method: "DELETE", url: `/api/pat/${id}` }),
      invalidatesTags: (_, error, id) =>
        invalidateTags(error, [
          listTag("personal-access-token"),
          idTag("personal-access-token", id),
        ]),
    }),
  }),
});

export const {
  useListCurrentPersonalAccessTokensQuery,
  useCreateCurrentPersonalAccessTokenMutation,
  useRevokeCurrentPersonalAccessTokenMutation,
  useListAdminPersonalAccessTokensQuery,
  useCountAdminPersonalAccessTokensQuery,
  useRevokeAdminPersonalAccessTokenMutation,
} = personalAccessTokenApi;
